// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__12hAv","actions":"GroupTable_actions__2dZrD","deleteModalFooter":"GroupTable_deleteModalFooter__3BlAC"};